import styled, { css } from 'styled-components'
import { ifProp, prop } from 'styled-tools'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'

export const Wrapper = styled.span`
  color: ${prop('color')};
  margin: ${prop('margin')};
  ${ifProp('disabled', `color: ${colorsOptions.greys['grey-60']};`)}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: ${prop('textalign')};
  ${ifProp(
    { as: 'p' },
    css`
      white-space: normal;
    `
  )}
  ${({ size = textStyleSizeOptions['TEXT-R'] }) =>
    textStyleWeightStyleOptions[size]};
  ${({ weight = textStyleWeightOptions['TEXT-500'] }) =>
    textStyleSizeStyleOptions[weight]};
`
